import { DataBean } from "../DataBean";

export class ProcessFactoryImp extends DataBean {



    public async getProcessFactoryImpCatalog(args:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProcessFactoryImpCatalog_Number", [args]);
    }
     public async updateProcessFactoryImp(bean:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.admin.ProcessFactoryImp_updateProcessFactoryImp_com.quickdataerp.bean.admin.ProcessFactoryImp", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.admin.ProcessFactoryImp"
            }
        ]);
    }
}